export var BUTTON_TYPES = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  caution: 'caution'
};
export var BUTTON_SIZES = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
export var TEXT_BUTTON_FONT_TYPES = {
  body: 'body',
  bodyHeading: 'bodyHeading',
  bodySmall: 'bodySmall',
  bodySmallHeading: 'bodySmallHeading'
};
export var TEXT_BUTTON_TYPES = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary'
};
export var BUTTON_SHAPES = {
  circle: 'circle',
  square: 'square'
};
export var ICON_BUTTON_SIZES = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};